import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M6 17.595H3c-.6 0-1-.39-1-.977v-2.933c0-.586-.4-.977-1-.977s-1 .39-1 .977v2.933c0 1.662 1.3 2.933 3 2.933h3c.6 0 1-.391 1-.978 0-.586-.4-.978-1-.978M6 0H3C1.3 0 0 1.271 0 2.933v2.932c0 .586.4.977 1 .977s1-.39 1-.977V2.932c0-.587.4-.978 1-.978h3c.6 0 1-.39 1-.977S6.6 0 6 0m11 0h-3c-.6 0-1 .391-1 .978 0 .586.4.977 1 .977h3c.6 0 1 .391 1 .978v2.932c0 .586.4.977 1 .977s1-.39 1-.977V2.932C20 1.27 18.7 0 17 0m2 12.709c-.6 0-1 .39-1 .978v2.932c0 .587-.4.978-1 .978h-3c-.6 0-1 .39-1 .977s.4.978 1 .978h3c1.7 0 3-1.27 3-2.933v-2.932c0-.587-.4-.978-1-.978"
    }, null, -1)
  ]))]))
}
export default { render: render }